import { privateInstance } from "../configs";

export const paycostApi = {
  async getPayCosts() {
    const res = await privateInstance.get("/employe/api/pay-cost/cl/");
    return res.data;
  },
  async retrievePayCost(id) {
    const res = await privateInstance.get(`/employe/api/pay-cost/rud/${id}/`);
    return res.data;
  },
  async postPayCost(paycost) {
    const res = await privateInstance.post(
      "/employe/api/pay-cost/cl/",
      paycost
    );
    return res.data;
  },
  async putPayCost(id, paycost) {
    const res = await privateInstance.put(
      `/employe/api/pay-cost/rud/${id}/`,
      paycost
    );
    return res.data;
  },
  async deletePayCost(id) {
    await privateInstance.delete(`/employe/api/pay-cost/rud/${id}/`);
  }
};
